import type { IComponentController } from "angular";

export default class SiteConfigurationGroupInstructionsInfoComponentController implements IComponentController {
    public static $inject: string[] = [];

    public heading: string;

    public instructions: string[];
}
